import catalog from './kagemane-catalog.generated.json';
import type { VideoReplicationReferenceRole } from '@/lib/api/video-replications';

export interface KagemaneTemplate {
  id: string;
  title?: string;
  slug: string;
  version: number;
  category: string;
  src: string;
  poster: string;
  previewSrc?: string;
  playbackSrc?: string;
  assetId?: string;
  width?: number;
  height?: number;
  previewPoster?: string;
  previewPlaceholder?: string;
  previewPosterSources?: { url: string; width: number; height: number }[];
  referenceVideo?: { src: string; poster: string; durationSeconds: number };
  referenceImages?: { url: string; name: string }[];
  referencePrompt?: string;
  aspectRatio: number;
  durationSeconds: number;
  uploadedAt: string;
  roles: { role: VideoReplicationReferenceRole; required: boolean }[];
}

export const KAGEMANE_TEMPLATES = [...catalog].sort(
  (a, b) => Date.parse(b.uploadedAt) - Date.parse(a.uploadedAt),
) as KagemaneTemplate[];

let currentTemplates = KAGEMANE_TEMPLATES;

export function setKagemaneTemplates(items: KagemaneTemplate[]): KagemaneTemplate[] {
  currentTemplates = [...items].sort((a, b) => Date.parse(b.uploadedAt) - Date.parse(a.uploadedAt));
  return currentTemplates;
}

export function findKagemaneTemplate(id: string | null): KagemaneTemplate | undefined {
  return currentTemplates.find((item) => item.id === id);
}

export function kagemanePath(templateId?: string, projectId?: string): string {
  const search = new URLSearchParams();
  if (templateId) search.set('template', templateId);
  if (projectId) search.set('project', projectId);
  return `/kagemane${search.size ? `?${search}` : ''}`;
}
